import { component } from 'picoapp'

export default component((node, ctx) => {

  const openClass = 'is-open';
  const headings = node.querySelectorAll('.accordion__heading')
  const contents = node.querySelectorAll('.accordion__content')

  if (headings.length !== contents.length) {
    throw 'mismatched amount of headings and contents'
  } else if (headings.length == 0) {
    return;
  }

  const toggleAccordion = function(e) {
    if (e.currentTarget.classList.contains(openClass)) {
      // closeAll();
    } else {
      e.preventDefault();
      const i = e.currentTarget.getAttribute('data-index');
      closeAll();
      open(i);
    }
  }

  const open = function(i, userInitiated = true) {
    headings[i].classList.add(openClass);
    contents[i].classList.add(openClass);

    if (userInitiated) {
      setTimeout(function() {
        headings[i].scrollIntoViewIfNeeded();
      }, 1);
    }
  }

  const close = function(i) {
    headings[i].classList.remove(openClass);
    contents[i].classList.remove(openClass);
  }

  const closeAll = function() {
    for (let i = 0; i < contents.length; i++) {
      close(i);
    }
  }

  for (let i = 0; i < headings.length; i++) {
    headings[i].setAttribute('data-index', i)
    headings[i].addEventListener('click', toggleAccordion)
  }

  const openedOnLoad = node.querySelector('.accordion__heading.' + openClass);
  if (openedOnLoad) {
    open(openedOnLoad.getAttribute('data-index'), false);
  } else {
    // open the first accordion in the group
    open(0, false);
  }

  // on a category page, open by the current sublink
  const activeSubCategory = node.querySelector('.collection-menu__sublink.current');
  if (activeSubCategory) {
    const parent = activeSubCategory.closest('.collection-menu__item');
    const parentHeading = parent.querySelector('.collection-menu__link');
    const index = parentHeading.dataset.index;
    closeAll();
    open(index, false);
  }

  // on a category page, we might be on a top-level category (Skin Care)
  const activeCategory = node.querySelector('.collection-menu__link.current.accordion__heading');
  if (activeCategory) {
    const index = activeCategory.dataset.index;
    closeAll();
    open(index, false);
  }



})
